import React, { useRef } from 'react';
import moment from 'moment';
import cn from '@/utils/cn';
import I18n from '@/modules/i18n';
import Drawer from '@/components/ui/Drawer';
import useOnClickOnKeys from '@/hooks/useOnClickOnKeys';
import Text from '@/components/ui/Text';
import useGradesTableStore from '@/components/staffer/AssignmentsBasedGradesTable/store/useGradesTableStore';
import { useLeftOffset } from './utils';
import { AssignmentDrawerTitle } from './AssignmentDrawerTitle';
import { ReadingAssignmentsTable } from '../ReadingAssignmentsTable';
import { ReadingAssignmentTableLegend } from './ReadingAssignmentTableLegend';

export function AssignmentDrawerContent() {
  const ref = useRef<HTMLButtonElement>();

  useOnClickOnKeys(ref, ['Escape']);
  const assignment = useGradesTableStore(state => state.assignment);
  const assignments = useGradesTableStore(state => state.assignments);
  const { leftOffset } = useLeftOffset();

  if (!assignment) return null;

  const assignmentIndex = assignments.findIndex(a => a.id === assignment.id);

  return (
    <>
      <Drawer.Overlay />
      <Drawer.Content
        className={cn(
          'tw-right-3 tw-shadow tw-z-9999 tw-rounded-t-2xl tw-ml-3',
          'tw-box-border tw-px-2 tw-bg-white tw-h-3/4',
        )}
        style={{ left: leftOffset }}
      >
        <Drawer.Header
          className={cn(
            'tw-text-left tw-flex tw-justify-between tw-py-2 tw-select-text',
            'tw-bg-tci-purple/10 -tw-mx-2 -tw-mt-2 tw-px-6 tw-box-border',
          )}
        >
          <Drawer.Title className="tw-flex tw-items-center tw-gap-4 tw-flex-grow tw-max-w-[75%]">
            <AssignmentDrawerTitle title={assignment.assignment_details.title} />
            <a className="tw-whitespace-nowrap" href="#" target="_blank" rel="noreferrer noopener">
              {`Assignment ${assignmentIndex + 1}`}
            </a>
          </Drawer.Title>
          <div className="tw-flex tw-items-center tw-gap-6 tw-min-w-max">
            <Text italic size="sm">
              {`${I18n.t('due_date_lower')}: ${moment(assignment.due_datetime).format('M/D/YY')}`}
            </Text>
            <Drawer.Close
              ref={ref}
              aria-label="Close dialog"
              className="tw-border-none tw-bg-inherit tw-text-lg tw-cursor-pointer"
            >
              ✕
            </Drawer.Close>
          </div>
        </Drawer.Header>
        <ReadingAssignmentsTable />
        <ReadingAssignmentTableLegend />
      </Drawer.Content>
    </>
  );
}
